<template name="login-form">
  <form class="login-form">
    <v-card-title class="justify-center mb-5">
      <h1 class="headline text-center primary--text">
        {{ $cmsService.getContent(content, 'login_label') }}
      </h1>
    </v-card-title>
    <v-card-text>
      <CustomAlert :show-alert="submitError" alert-type="error">
        <span class="body-2">{{ loginErrorMsg }}</span>
      </CustomAlert>
      <v-text-field
        id="email"
        v-model="email"
        class="cms_eMail"
        :label="$cmsService.getContent(content, 'email_address')"
        :error-messages="emailErrors"
        outlined
        dense
        required
        @input="$v.email.$touch()"
        @keyup.enter.native="submit()"
      ></v-text-field>
      <v-text-field
        id="password"
        v-model="pwd"
        class="cms_pw"
        :label="$cmsService.getContent(content, 'password')"
        :error-messages="pwdErrors"
        :type="showPwd ? 'text' : 'password'"
        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
        outlined
        dense
        required
        @input="$v.pwd.$touch()"
        @keyup.enter.native="submit()"
        @click:append="showPwd = !showPwd"
      ></v-text-field>
      <br />
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn
        id="login"
        class="text-center px-8"
        color="primary"
        dark
        depressed
        @click.stop="submit"
        >{{ $cmsService.getContent(content, 'login_label') }}</v-btn
      >
    </v-card-actions>
  </form>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import CustomAlert from '@/components/CustomAlert'
import loginFormJson from '@/data/json/forms/forms.json'

export default {
  components: {
    CustomAlert
  },
  mixins: [validationMixin],
  validations: {
    email: { required, email },
    pwd: {
      required,
      minLength: minLength(6)
    }
  },
  data: () => ({
    content: loginFormJson.data,
    email: '',
    pwd: '',
    showPwd: false,
    submitError: false,
    loginErrorMsg: ''
  }),
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push(this.getError('email_invalid'))
      !this.$v.email.required && errors.push(this.getError('email_necessary'))
      return errors
    },
    pwdErrors() {
      const errors = []
      if (!this.$v.pwd.$dirty) return errors
      !this.$v.pwd.required && errors.push(this.getError('password_necessary'))
      !this.$v.pwd.minLength &&
        errors.push(this.getError('password_min_length'))
      return errors
    }
  },
  methods: {
    ...mapActions(['loginUser']),
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitError = true
        this.loginErrorMsg = this.getError('validator_message')
      } else {
        return this.loginUser({
          username: this.email,
          password: this.pwd,
          rememberLogin: true,
          returnUrl: '/dashboard'
        })
          .then(() => {
            this.$router.push('/dashboard')
          })
          .catch(e => {
            this.submitError = true
            this.loginErrorMsg = this.getError(e.response.status)
          })
      }
    },
    getError: function (errorKey) {
      return this.$store.getters.error({
        errorKey: errorKey,
        route: this.$route.name
      })
    },
    clear() {
      this.$v.$reset()
      this.email = ''
      this.pwd = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.border--dotted {
  border-bottom: 1px dotted var(--v-primary-base);
}
</style>
